import React from 'react';

const CalendarIcon = () => (
  <svg 
    className="w-5 h-5 text-gray-500 dark:text-gray-400 transition-colors"
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5"
    strokeLinecap="round"
  >
    <path d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18"/>
  </svg>
);

export default CalendarIcon; 